import { defineStore } from 'pinia'
import { ref } from 'vue'
import { UserChannelType } from '@da-vinci/shared'
import { IListReq, IResponseList } from '@da-vinci/utils'

export const useAiVideoStore = defineStore('aiVideo', () => {
  const symbolAiRecords = ref(Symbol('symbolAiRecords'))
  function openAiRecords() {
    symbolAiRecords.value = Symbol('symbolAiRecords')
  }

  return { openAiRecords, symbolAiRecords }
})

export interface AnalysisTask {
  taskId: string
  status: 'doing' | 'finish' | 'fail'
  videoMd5: string
  videoUrl: string
  videoImageUrl: string
  channel: UserChannelType
  videoTitle: string
  gmtCreate: string
}

export type IQueryTaskList = (data: IListReq) => Promise<IResponseList<AnalysisTask>>
export type IQueryTaskDetail = (data: { taskIds: string[] }) => Promise<IResponseList<AnalysisTask>>

export { default as VAIAnalysisRecords } from './index.vue'
